import axios from "../axios/axios";
import { appSetDashboardGuideData, appSetGuideData, appSetLoading } from "../store/actions/appAction";
import {
  setBuyFactor,
  setBuysChart,
  setCostsChart,
  setCreditors,
  setDashboard,
  setDashboardFinancials,
  setDebtors,
  setIncomesChart,
  setLatestAccountings,
  setPaymentCheques,
  setProfitAndLoss,
  setRecieveCheques,
  setSalesChart,
  setSellFactor,
  setTopBuys,
  setTopSales,
} from "../store/actions/dashboardAction";
import { errorDispatcher } from "../helpers";

export const apiGetDashboard = (businessId, token, options) => (dispatch, getState) => {
  // dispatch(appSetLoading());
  axios
    .get(`dashboard?businessId=${businessId}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      dispatch(setDashboard(response.data));
      // dispatch(appSetLoading(false));
    })
    .catch((error) => {
      dispatch(setDashboard(undefined));
      // dispatch(appSetLoading(false));
      !options?.noAlert && errorDispatcher(error, dispatch);
    });
};
export const apiGetDebtors = (token, changeLoading) => (dispatch, getState) => {
  // dispatch(appSetLoading());
  changeLoading()
  axios
    .get(`/dashboard/debtors`, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      dispatch(setDebtors(response.data));
      // dispatch(appSetLoading(false));
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};
export const apiGetCreditors = (token, changeLoading) => (dispatch, getState) => {
  // dispatch(appSetLoading());
  changeLoading()
  axios
    .get(`/dashboard/creditors`, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      dispatch(setCreditors(response.data));
      // dispatch(appSetLoading(false));
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    }).finally(() => changeLoading())
};
export const apiGetReceiveCheques = (token, changeLoading) => (dispatch, getState) => {
  changeLoading()
  // dispatch(appSetLoading());
  axios
    .get(`/dashboard/receiveCheque`, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      dispatch(setRecieveCheques(response.data));
      // dispatch(appSetLoading(false));
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    }).finally(() => {
      changeLoading()
    }
    )
};
export const apiGetPaymentCheques = (token, changeLoading) => (dispatch, getState) => {
  // dispatch(appSetLoading());
  changeLoading()
  axios
    .get(`/dashboard/paymentCheque`, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      dispatch(setPaymentCheques(response.data));
      // dispatch(appSetLoading(false));
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    }).finally(() => {
      changeLoading()
    })
};
export const apiGetDashboardFinancials = (token, changeLoading) => (dispatch, getState) => {
  // dispatch(appSetLoading());
  changeLoading()
  axios
    .get(`/dashboard/banking`, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      dispatch(setDashboardFinancials(response.data.financials));
      // dispatch(appSetLoading(false));
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};
export const apiGetTopSales = (token, filterType,changeLoading) => (dispatch, getState) => {
  // dispatch(appSetLoading());
  changeLoading()
  axios
    .get(`/dashboard/topSales${filterType ? `?filterType=${filterType}` : ""}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      dispatch(setTopSales(response.data.topSales));
      // dispatch(appSetLoading(false));
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    }).finally(()=>{
      changeLoading()
    });
};
export const apiGetTopBuys = (token, filterType,changeLoading) => (dispatch, getState) => {
  // dispatch(appSetLoading());
  changeLoading()
  axios
    .get(`/dashboard/topBuys${filterType ? `?filterType=${filterType}` : ""}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      dispatch(setTopBuys(response.data.topBuys));
      // dispatch(appSetLoading(false));
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    }).finally(() => {
      changeLoading()
    })
};
export const apiGetBuyFactor = (token, changeLoading) => (dispatch, getState) => {
  // dispatch(appSetLoading());
  changeLoading()
  axios
    .get(`/dashboard/buysFactor`, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      dispatch(setBuyFactor(response.data.buysFactor));
      // dispatch(appSetLoading(false));
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    }).finally(()=>{
      changeLoading()
    })
};
export const apiGetSellFactor = (token, changeLoading) => (dispatch, getState) => {
  // dispatch(appSetLoading());
  axios
    .get(`/dashboard/salesFactor`, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      dispatch(setSellFactor(response.data.salesFactor));
      // dispatch(appSetLoading(false));
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};
export const apiGetProfitAndLoss = (token, filterType, changeLoading) => (dispatch, getState) => {
  // dispatch(appSetLoading());
  changeLoading()
  axios
    .get(`/dashboard/profitAndLoss${filterType ? `?filterType=${filterType}` : ""}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      dispatch(setProfitAndLoss(response.data.profitAndLoss));
      // dispatch(appSetLoading(false));
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    }).finally(() => {
      changeLoading()
    });
};
export const apiGetLatestAccounting = (token, changeLoading) => (dispatch, getState) => {
  // dispatch(appSetLoading());
  changeLoading()
  axios
    .get(`/dashboard/latestAccountings`, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      dispatch(setLatestAccountings(response.data.latestAccountings));
      // dispatch(appSetLoading(false));
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    }).finally(()=>{
      changeLoading()
    })
};

export const apiGetSalesChart = (token, filterType,changeLoading) => (dispatch, getState) => {
  // dispatch(appSetLoading());
  changeLoading()
  
  axios
    .get(`/dashboard/salesChart${filterType ? `?filterType=${filterType}` : ""}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      dispatch(setSalesChart(response.data.salesChart));
      // dispatch(appSetLoading(false));
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    }).finally(()=>{
      changeLoading()
    })
};
export const apiGetBuysChart = (token, filterType,changeLoading) => (dispatch, getState) => {
  // dispatch(appSetLoading());
  changeLoading()
  axios
    .get(`/dashboard/buysChart${filterType ? `?filterType=${filterType}` : ""}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      dispatch(setBuysChart(response.data.buysChart));
      // dispatch(appSetLoading(false));
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    }).finally(()=>{
      changeLoading()
    })
};
export const apiGetIncomesChart = (token, filterType, changeLoading) => (dispatch, getState) => {
  // dispatch(appSetLoading());
  changeLoading()
  axios
    .get(`/dashboard/incomesChart${filterType ? `?filterType=${filterType}` : ""}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      dispatch(setIncomesChart(response.data.incomesChart));
      // dispatch(appSetLoading(false));
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    }).finally(() => {
      changeLoading()
    })
};
export const apiGetCostsChart = (token, filterType, changeLoading) => (dispatch, getState) => {
  // dispatch(appSetLoading());
  changeLoading()
  axios
    .get(`/dashboard/costsChart${filterType ? `?filterType=${filterType}` : ""}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      dispatch(setCostsChart(response.data.costsChart));
      // dispatch(appSetLoading(false));
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    }).finally(() => {
      changeLoading()
    })
};

export const apiGetGuides = (token, changeLoading) => (dispatch, getState) => {
  axios
    .get("dashboard/videoGuides", {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      dispatch(appSetGuideData(response?.data?.videos));
    })
    .catch((error) => {
      errorDispatcher(error, dispatch, false);
    });
};
export const apiGetDashboardGuides = (token, changeLoading) => (dispatch, getState) => {
  axios
    .get("dashboard/hasFactor", {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      // if (response.data.hasFactor) {
      //   dispatch(appSetGuide());
      // }
      dispatch(appSetDashboardGuideData(!response?.data?.hasFactor));
    })
    .catch((error) => {
      errorDispatcher(error, dispatch, false);
    });
};

